import Immutable from 'immutable';
import { ConnectDragPreview, ConnectDragSource, DragSourceMonitor, useDrag } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { ARTBOARD_CELL_ACCEPTED_DROP_TYPE } from 'components/ArtboardCell/useArtboardCellDropTarget';
import { EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import { documentIdsAreBeingUploaded as documentIdsAreBeingUploadedSelector } from 'containers/Project/selectors';
import { AssetDragObject, ReferenceCitationMap } from 'models';

type Props = {
  component: ReferenceCitationMap;
};

type DragSourceHook = {
  isDragging: boolean;
  dragRef: ConnectDragSource;
  preview: ConnectDragPreview;
  documentIdsAreBeingUploaded: Immutable.Set<string>;
};

export const useCitationItemDragSource = ({ component }: Props): DragSourceHook => {
  const dispatch = useDispatch();
  const documentIdsAreBeingUploaded = useSelector(documentIdsAreBeingUploadedSelector);
  const dragSourceType = ARTBOARD_CELL_ACCEPTED_DROP_TYPE;
  const componentType = EntityType.REFERENCE_CITATION;
  const [{ isDragging }, dragRef, preview] = useDrag<AssetDragObject, void, { isDragging: boolean }>({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType, componentType));

      return {
        type: componentType,
        component,
      };
    },
    canDrag() {
      return !documentIdsAreBeingUploaded.has(component.get('id'));
    },
    end: () => {
      dispatch(toggleDragState());
    },
    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return {
    isDragging,
    dragRef,
    preview,
    documentIdsAreBeingUploaded,
  };
};
